module.exports = __webpack_public_path__ + "media/NeueHaasUnicaW1G-Heavy.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/NeueHaasUnicaW1G/NeueHaasUnicaW1G-Heavy.woff2
// module id = 1579
// module chunks = 57